// Module-level store so the axios interceptors (which live outside React) can
// read the current migration state and open the global read-only modal.

let migrated = false;
const blockedListeners = new Set<() => void>();

export const setMigrated = (value: boolean): void => {
  migrated = value;
};

export const isMigrated = (): boolean => migrated;

export const subscribeBlocked = (listener: () => void): (() => void) => {
  blockedListeners.add(listener);
  return () => {
    blockedListeners.delete(listener);
  };
};

export const notifyBlocked = (): void => {
  blockedListeners.forEach((listener) => listener());
};

// Test helper — resets all module state between tests.
export const resetMigrationStore = (): void => {
  migrated = false;
  blockedListeners.clear();
};
